import { AbilitySubjectsRegistry } from '@core/shared/ability';
import { FeatureRegistry } from '@core/shared/feature';
import { ModelRegistryService } from '@core/shared/model';
import { FrontendAbilitySubjectsRegistry } from './ability-subjects.registry';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/ability";
export let CoreAbilitiesModule = /*#__PURE__*/(() => {
  class CoreAbilitiesModule {
    constructor(x) {}
    static {
      this.ɵfac = function CoreAbilitiesModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreAbilitiesModule)(i0.ɵɵinject(i1.AbilitySubjectsRegistry));
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CoreAbilitiesModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [
        // FrontendAbilitySubjectsRegistry is provided in root already
        {
          provide: AbilitySubjectsRegistry,
          useExisting: FrontendAbilitySubjectsRegistry,
          deps: [FeatureRegistry, ModelRegistryService]
        }]
      });
    }
  }
  return CoreAbilitiesModule;
})();